import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getQuantityPerScreenAPI,
} from "@icarius-connection/api";

export const getQuantityPerScreenAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_QUANTITY_PER_SCREEN });
  try {
    let response = await getQuantityPerScreenAPI();
    let quantityPerScreen = response.data && response.data.result;

    dispatch({
      type: actionTypes.GET_QUANTITY_PER_SCREEN_FULFILLED,
      payload: { quantityPerScreen },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_QUANTITY_PER_SCREEN_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};